import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	Tag,
	Input,
	Row,
	Col,
	notification,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
import hasPermission from "../../utils/permissions";
const { Text } = Typography;
const { Search } = Input;

const Permissions = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [term, setTerm] = useState("");
	const [permissionList, setPermissionList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		hasPermission("settings:permissions:update") && {
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Button
						type="primary"
						icon={<EditFilled twoToneColor={"white"} />}
						onClick={(e) => history.push(`/permissions/update/${record.id}`)}
						size="large"
					/>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Roles",
			dataIndex: "rolesPermission",
			key: "rolesPermission",
			render: (value) => {
				return (
					<Row gutter={[16, 16]}>
						{value.map((item, index) => (
							<Col key={index}>
								<Tag>{item}</Tag>
							</Col>
						))}
					</Row>
				);
			},
		},
		{
			title: "Users",
			dataIndex: "userPermission",
			key: "userPermission",
			render: (value) => {
				return (
					<Row gutter={[16, 16]}>
						{value.map((item, index) => (
							<Col key={index}>
								<Tag>{item}</Tag>
							</Col>
						))}
					</Row>
				);
			},
		},
	].filter(Boolean);

	useEffect(() => {
		getDriverList(term);
	}, [term]);

	const getDriverList = async (term) => {
		setLoading(true);

		const url = api + `/permission/get/list/search?term=${term}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
						description: item.description,
						rolesPermission: item.rolesPermission,
						userPermission: item.userPermission.map(
							(user) => `${user.name} (${user.email})`,
						),
					});
				});
				setPermissionList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to get permissions";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const addNewPermission = () => {
		history.push("/permissions/new");
	};

	const RenderSearch = () => (
		<Flex gap={"large"} justify="space-between">
			<Search
				placeholder="Search"
				enterButton
				onSearch={(value) => setTerm(value)}
				allowClear
				style={{
					width: 400,
				}}
				size="large"
				loading={loading}
				disabled={loading}
			/>
			{hasPermission("settings:permissions:create") && (
				<Button
					onClick={addNewPermission}
					type="primary"
					style={{
						width: 150,
					}}
					icon={<PlusCircleFilled />}
					size="large"
					loading={loading}
				>
					New Permission
				</Button>
			)}
		</Flex>
	);

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={permissionList} />
			</Flex>
		);
	};

	return (
		<Layout title="Permissions" description="Permissions by role and user">
			<Flex vertical gap={"large"}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default Permissions;
